module.exports = global["_"] = require("-!./underscore.js");


//////////////////
// WEBPACK FOOTER
// ./~/underscore/underscore.js
// module id = 12
// module chunks = 0 1